import React, { createContext, useState, useEffect } from "react";
import clientV3 from "./apolloClient";
import {
  COUPON_APPLY,
  REMOVE_ARRANGER_COUPON,
} from "./queries/insiderDashboard/loyaltyProgramQuery";
import { SOURCE_TYPE_COUPON } from "./config/constants";

export const LoyaltyProgramContext = createContext();

export const LoyaltyProgramProvider = ({ children }) => {
  const [loyaltyProgramStates, setLoyaltyProgramStates] = useState({
    codeLoading: false,
    couponCode: "",
    couponName: "",
    couponDisAmount: 0,
    couponCurrency: "",
    bookingTotalPrice: 0,
    bookingBalance: 0,
    couponApplyError: "",
    reservationId: null,
  });

  const handleCouponApply = (
    couponCode,
    arrangerCouponId,
    couponName,
    reservationId,
    productTypeId,
  ) => {
    setLoyaltyProgramStates((prev) => ({
      ...prev,
      codeLoading: true,
      couponApplyError: "",
    }));

    clientV3()
      .mutate({
        mutation: COUPON_APPLY,
        variables: {
          input: {
            arranger_coupon_id: arrangerCouponId,
            reservation_id: reservationId,
            product_type_id:
              productTypeId && productTypeId !== "" ? productTypeId : null,
          },
        },
      })
      .then((res) => {
        let resData = res?.data?.couponApply;
        if (resData.sources && resData.sources.length > 0) {
          let getprice = resData.sources.find(
            (val) => val.source_type_id === SOURCE_TYPE_COUPON,
          );
          setLoyaltyProgramStates((prev) => ({
            ...prev,
            codeLoading: false,
            couponDisAmount: getprice
              ? getprice?.customer_charge?.physical_amount
              : 0,
            couponCurrency: getprice
              ? getprice?.customer_charge?.physical_currency
              : "",
            couponCode: couponCode,
            couponName: couponName,
            couponApplyError: "",
            bookingTotalPrice: resData.total.physical_amount,
            bookingBalance:
              resData.balance?.physical_amount ?? resData.total.physical_amount,
            reservationId: reservationId || prev.reservationId,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
        setLoyaltyProgramStates((prev) => ({
          ...prev,
          codeLoading: false,
          couponApplyError: err.message.replace(/GraphQL error:/g, ""),
        }));
      });
  };

  const handleRemoveCoupon = (arrangerCouponId, reservationId) => {
    setLoyaltyProgramStates((prev) => ({
      ...prev,
      codeLoading: true,
      couponApplyError: "",
    }));

    clientV3()
      .mutate({
        mutation: REMOVE_ARRANGER_COUPON,
        variables: {
          input: {
            arranger_coupon_id: arrangerCouponId,
            reservation_id: reservationId
              ? String(reservationId)
              : String(loyaltyProgramStates?.reservationId || ""),
          },
        },
      })
      .then((res) => {
        let resData = res.data.removeCoupon;
        if (resData) {
          setLoyaltyProgramStates((prev) => ({
            ...prev,
            codeLoading: false,
            couponCode: "",
            couponName: "",
            couponDisAmount: 0,
            couponCurrency: "",
            couponApplyError: "",
            bookingTotalPrice: resData.total.physical_amount,
            bookingBalance:
              resData.balance?.physical_amount ?? resData.total.physical_amount,
            reservationId:
              reservationId || prev.reservationId || loyaltyProgramStates?.reservationId,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
        setLoyaltyProgramStates((prev) => ({
          ...prev,
          codeLoading: false,
          couponApplyError: err.message.replace(/GraphQL error:/g, ""),
        }));
      });
  };

  useEffect(() => {
    if (loyaltyProgramStates?.couponApplyError !== "") {
      const timer = setTimeout(() => {
        setLoyaltyProgramStates((prev) => ({
          ...prev,
          couponApplyError: "",
        }));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [loyaltyProgramStates?.couponApplyError]);

  return (
    <LoyaltyProgramContext.Provider
      value={{
        loyaltyProgramStates,
        setLoyaltyProgramStates,
        handleCouponApply,
        handleRemoveCoupon,
      }}
    >
      {children}
    </LoyaltyProgramContext.Provider>
  );
};
